export const classes = {
  root: {
    position: 'relative',
    boxSizing: 'content-box',
  },
};
